<template>
  <div class="home">
<Navigation/>
    <div class="section bg-primary-3">
    <div class="container text-center">
      <h1>This or That</h1>
      <div class="text-large">To be or not to be? Shakespeare had the right idea.</div>
    </div>
  </div>
<Posts Category="this-or-that" />


  </div>

</template>

<script>
import Navigation from "@/components/Navigation.vue"
import Posts from "@/components/PostCollection.vue"

export default {
  name: "home",
  components: {
    Navigation,
    Posts
  }
};
</script>
